var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isClubActivityPage)?_c('div',{staticClass:"w-3/12 lg:w-1/5 2xl:w-2/12 h-full overflow-y-auto ml-2 mr-1 flex-col hidden lg:inline-flex sm:pr-2"},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }